import React from 'react'
import { func } from 'prop-types'
import { useTranslation } from 'react-i18next'

require('./MagicEraserTutorial.scss')

const MagicEraserTutorial = ({ onSeen }) => {
    const { t } = useTranslation()

    return (
        <div className="MagicEraserTutorial">
            <div className="tutorialWindow">
                <h2>{t('design.no heavy lifting required')}</h2>
                <p>{t('design.magic eraser explanation')}</p>
                <button onClick={onSeen}>{t('common.get started')}</button>
            </div>
        </div>
    )
}

MagicEraserTutorial.propTypes = {
    onSeen: func.isRequired,
}

export default MagicEraserTutorial
